import { DEFAULT_ICONS } from "@/modules/Home/constants/HomeConstants";
import { DashboardCard } from "./../models/DashboardCard";
import { FILTERS_LIST } from "../AdminDashboard/constants/AdminDashboardConstants";

const sortAlphabetically = (tagsArray: DashboardCard[]): DashboardCard[] => {
  return tagsArray.sort(function(a, b) {
    if (a.title < b.title) {
      return -1;
    }
    if (a.title > b.title) {
      return 1;
    }
    return 0;
  });
};

const INFO_CARD_FORM: DashboardCard = {
  canShow: ["list", "formTemplate"],
  title: "Formularios y listas",
  titleSub: "Cree y edite el estado de listas y formularios",
  icon: {
    avatar: "mdi-content-paste",
    color: "#69D1C5",
    background: "#e4f7f5"
  },
  children: sortAlphabetically([
    { canShow: ["list"], title: "Lista", pathName: "List" },
    {
      canShow: ["formTemplate"],
      title: "Formularios",
      pathName: "FormTemplate"
    }
  ])
};

const INFO_CARD_USER: DashboardCard = {
  canShow: ["infoGroup", "userTemplate", "user", "roles", "dependencies"],
  title: "Usuarios",
  titleSub: "Cree y edite la información de los usuarios en la base de datos",
  icon: { avatar: "mdi-account", color: "#8937EF", background: "#eadbfc" },
  children: sortAlphabetically([
    {
      canShow: ["infoGroup"],
      title: "Grupos de información",
      pathName: "InfoGroup"
    },
    {
      canShow: ["userTemplate"],
      title: "Plantillas de usuario",
      pathName: "UserTemplate"
    },
    { canShow: ["user"], title: "Usuarios", pathName: "User" },
    { canShow: ["roles"], title: "Roles", pathName: "Roles" },
    {
      canShow: ["dependencies"],
      title: "Dependencias",
      pathName: "Dependencies"
    }
  ])
};

const INFO_CARD_SERVICE: DashboardCard = {
  canShow: ["cupsPriceLevels", "sessionTemplates", "serviceTemplates"],
  title: "Servicios",
  titleSub: "Cree y edite el estado la información de los servicios",
  icon: { avatar: "mdi-shape-plus", color: "#63C7E7", background: "#c4eaf6" },
  children: sortAlphabetically([
    {
      canShow: ["cupsPriceLevels"],
      title: "Nivel de precio",
      pathName: "CupsPriceLevel"
    },
    {
      canShow: ["sessionTemplates"],
      title: "Sesiones",
      pathName: "SessionTemplates"
    },
    {
      canShow: ["serviceTemplates"],
      title: "Servicios",
      pathName: "ServicesTemplate"
    }
  ])
};

const INFO_CARD_ADMIN_RULES: DashboardCard = {
  canShow: ["generalRules"],
  title: "Reglas",
  titleSub: "Cree y edite automatizaciones",
  icon: { avatar: "mdi-sitemap", color: "#9B5897", background: "#ecdfeb" },
  pathName: "GeneralRules"
};

const INFO_CARD_ADMIN_TEMPLATE: DashboardCard = {
  canShow: [
    "templatePdf",
    "notificationTemplate",
    "saveOrderTemplate",
    "multimedia"
  ],
  title: "Plantillas",
  titleSub:
    "Cree y edite plantillas informativas, para notificar o de multimedia",
  icon: {
    avatar: "mdi-text-box-multiple",
    color: "#f7a072",
    background: "#ffeae0"
  },

  children: sortAlphabetically([
    {
      canShow: ["templatePdf"],
      title: "Plantillas PDF",
      pathName: "TemplatePdf"
    },
    {
      canShow: ["notificationTemplate"],
      title: "Notificaciones",
      pathName: "NotificationTemplate"
    },
    {
      canShow: ["saveOrderTemplate"],
      title: "Órdenes",
      pathName: "SaveOrderTemplate"
    },
    {
      canShow: ["multimedia"],
      title: "Multimedia",
      pathName: "Multimedia"
    },
    {
      canShow: ["actionPlan"],
      title: "Plan de Acción",
      pathName: "ActionPlan"
    }
  ])
};

const INFO_CARD_ADMIN_SHEDULING: DashboardCard = {
  canShow: ["availability", "campus", "space"],
  title: "Agendamiento",
  titleSub: "Cree y edite las disponibilidades en la agenda",
  icon: {
    avatar: "mdi-calendar-blank",
    color: "#F39A9D",
    background: "#F39A9D3B"
  },
  children: sortAlphabetically([
    {
      canShow: ["availability"],
      title: "Disponibilidades",
      pathName: "Availability"
    },
    {
      canShow: ["campus"],
      title: "Sedes",
      pathName: "Campus"
    },
    { canShow: ["space"], title: "Espacios", pathName: "Space" }
  ])
};

const INFO_CARD_ORDER: DashboardCard = {
  canShow: ["saveMedicalOrder"],
  title: "Órdenes",
  titleSub: "Cree y edite órdenes médicas",
  icon: { avatar: "mdi-receipt-text", color: "#2586AC", background: "#bfe1eb" },

  children: sortAlphabetically([
    {
      canShow: ["saveMedicalOrder"],
      title: "Crear orden",
      pathName: "MedicalOrder"
    },
    {
      canShow: ["saveMedicalOrder"],
      title: "Cargar ordenes",
      pathName: "LoadOrders"
    }
  ])
};

export const DASHBOARD_TEMPLATE: DashboardCard[] = [
  INFO_CARD_FORM,
  INFO_CARD_USER,
  INFO_CARD_SERVICE,
  INFO_CARD_ADMIN_RULES,
  INFO_CARD_ADMIN_TEMPLATE,
  INFO_CARD_ADMIN_SHEDULING,
  INFO_CARD_ORDER
];

export const INFO_CARD_TEMPLATE: DashboardCard = {
  canShow: [
    ...INFO_CARD_FORM.canShow,
    ...INFO_CARD_USER.canShow,
    ...INFO_CARD_SERVICE.canShow,
    ...INFO_CARD_ADMIN_RULES.canShow,
    ...INFO_CARD_ADMIN_TEMPLATE.canShow,
    ...INFO_CARD_ADMIN_SHEDULING.canShow,
    ...INFO_CARD_ORDER.canShow
  ],
  title: "Plantillas",
  titleSub: "Cree , edite y actualice información",
  icon: { avatar: "mdi-receipt-text", color: "#6AD1C5", background: "#D0F2EE" },
  pathNameAux: "Templates",
  isPanelLateral: true,
  children: sortAlphabetically(DASHBOARD_TEMPLATE)
};

const ADMIN_DASHBOARD_OPTIONS = FILTERS_LIST.map(item => {
  return {
    canShow: ["adminDashboard"],
    title: item.mainFilterName,
    pathName: "AdminDashboard",
    query: { type: item.mainFilterKey }
  };
});

const INFO_CARD_ADMIN_TABLE: DashboardCard = {
  canShow: ["adminDashboard"],
  title: "Panel administrativo",
  titleSub: "Consulte información administrativa",
  icon: { avatar: "mdi-chart-bar", color: "#8937EF", background: "#8937EF3B" },
  isPanelLateral: true,
  pathNameAux: "AdminDashboard",
  children: sortAlphabetically(ADMIN_DASHBOARD_OPTIONS)
};

const INFO_CARD_SCHEDULING: DashboardCard = {
  canShow: ["doctorProfile"],
  title: "Agenda",
  titleSub: "Cree y gestione la disponibilidad de su agenda",
  icon: {
    avatar: "mdi-calendar-multiselect-outline",
    color: "#a75495",
    background: "#ecd7e6"
  },
  pathName: "DoctorProfile",
  urlUser: true,
  isPanelLateral: true
};

export const INFO_CARD_TASK: DashboardCard = {
  canShow: ["task"],
  title: "Tareas",
  titleSub: "Tareas por realizar",
  icon: {
    avatar: " mdi-clipboard-outline ",
    color: "#F7A072",
    background: "#fef2eb"
  },
  openLateralMenu: DEFAULT_ICONS[1].key,
  floatReference: "taskNumber"
};

export const DASHBOARD_PRINCIPAL: DashboardCard[] = [
  INFO_CARD_TEMPLATE,
  INFO_CARD_ADMIN_TABLE,
  INFO_CARD_SCHEDULING,
  INFO_CARD_TASK
];

export const DASHBOARD_CONST = {
  HOME: {
    TITLE: "Bienvenido, "
  },
  TEMPLATE: {
    TITLE: "Plantillas"
  }
};

export const GROUPER_KEYS = {
  SERVICE_INTERNAL_NAME: "serviceInternalName",
  CUPS: "cups",
  FORM_NAME: "formName",
  NAME: "name",
  TASK_FORM_TEMPLATE: "taskFormTemplate"
};
